/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, {FC, useContext, useEffect, useState} from 'react'
import { Context } from '../../../context/OffersContext'
import { BaseInput, FileInput, SwitchInput, Text, TextareaInput } from '../../atoms'
import { ContentSection } from '../../organisms'
import {useParams} from "react-router-dom";
import Select from "react-select";
import { CATEGORIES_ALL } from '../../../category_all'
import * as styles from "../Header/index.styles";
import {useSelector} from "react-redux";

const OffersForm: FC = () => {
  const { formData, handleChangeFormData: handleChange, handleUpdateFormData: handleData } = useContext(Context)
  let { id } = useParams();
  const detail_data = useSelector((state: any) => state.offers.data)
  const offers_data = id ? detail_data?.find((r:any) => r.id === parseInt(id+'')) : null
  const [isCycleValid, setIsCycleValid] = useState<boolean>(false)

  const validateNumber = (data: string) =>
    /^[0-9]+$/.test(data)

  useEffect(() => {
    if (!!id) {
      handleData(offers_data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, offers_data])

  const categoryInit = offers_data?.category ? { value: offers_data.category, label: offers_data.category } : { value: '', label: '' }

  const handleCategory = (e: any) => {
    handleChange({ category: e.value })
  }

  const [isTitleValid, setTitleValid] = useState<boolean>(false)
  const [isDescriptionValid, setIsDescriptionValid] = useState<boolean>(false)
  const [isUrlValid, setIsUrlValid] = useState<boolean>(false)

  useEffect(() => {
    setTitleValid(formData.title.length > 2)
  }, [formData.title])
  useEffect(() => {
    setIsDescriptionValid(formData.description.length > 2)
  }, [formData.description])
  useEffect(() => {
    setIsUrlValid(formData.url.length > 10)
  }, [formData.url])
  useEffect(() => {
    setIsCycleValid(validateNumber(formData.cycle))
  }, [formData.cycle])

  return (
    <ContentSection style={css`display: grid;gap: 18px;`}
      header={
        <React.Fragment>
          <Text textType="h4" weight="black">
            {id ? 'Editar':'Nueva'} oferta
          </Text>
        </React.Fragment>
      }
    >
      <BaseInput label="Título"
        value={formData.title}
        onChange={(value) => handleChange({ title: value })}
        placeholder="Escribe el titulo de tu entrada"
                 maxLength={500}
                 error={!isTitleValid && formData.title.length > 0}
                 success={isTitleValid}
                 hint={!isTitleValid && formData.title.length > 0 ? 'Digite mas de dos letras' : ''}
      />
      <TextareaInput
          label="Contenido"
          value={formData.description}
          onChange={(value) => handleChange({ description: value })}
          placeholder="Escribe el contenido de tu entrada"
          maxLength={1500}
          error={!isDescriptionValid && formData.description.length > 0}
          success={isDescriptionValid}
          hint={!isDescriptionValid && formData.description.length > 0 ? 'Digite mas de dos letras' : ''}
      />
      <BaseInput
          label="URL"
          value={formData.url}
          onChange={(value) => handleChange({ url: value })}
          placeholder="Escribe el enlace del evento"
          maxLength={1500}
          error={!isUrlValid && formData.url.length > 0}
          success={isUrlValid}
          hint={!isUrlValid && formData.url.length > 0 ? 'Introduce una url Ej.:https://www.google.com/' : ''}
      />
      <BaseInput
        label="Ciclo"
        placeholder="Escribe un código de  ciclo"
        value={formData.cycle}
        onChange={(value) => handleChange({ cycle: value })}
        maxLength={30}
        error={!isCycleValid && formData.cycle.length > 0}
        success={isCycleValid}
        hint={!isCycleValid && formData.cycle.length > 0 ? 'Digite numeros' : ''}
      />
      <Text textType="label">
        CATEGORÍA :{' '}
        <Select css={styles.input}
          options={CATEGORIES_ALL}
          defaultValue={categoryInit}
          onChange={(e) =>  handleCategory(e)}
        />
      </Text>

      <div style={{ width: 360 }}>
        <FileInput
          label="Imagen"
          value={formData.image}
          onChange={(value) => handleChange({ image: value })}
          accept="image/*"
        />
      </div>
      <div style={{ width: 360 }}>
        <FileInput
          label="Imagen descripción"
          value={formData.image_description}
          onChange={(value) => handleChange({ image_description: value })}
          accept="image/*"
        />
      </div>
      <SwitchInput checked={formData.active}
                   onCheckedChange={(value) => handleChange({ active: value })}
                   label={formData.active ? 'Activo': 'Inactivo'}
      />
    </ContentSection>
  )
}

export default OffersForm
